import {AppstoreOutlined, CalendarOutlined, EnvironmentOutlined} from '@ant-design/icons';
import cn from 'classnames';
import React, {useEffect, useState} from 'react';

import objectDefaultImage from '../../../../assets/images/default/objectDefaultImage.png';
import * as localizedKeys from '../../../consts/localization/localizationKeys';
import * as routePaths from '../../../consts/route/routePaths';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import {IconLocationYellow} from '../../Icons';
import BuildingOptionsMenu from '../../TableOptionsMenu/BuildingOptionsMenu/BuildingOptionsMenu';

const ObjectImageCard = (props) => {
    const localizedStrings = getLocalizedStrings();
    const {objectData, roomsCount, children, className, isMenuButtonVisible, mobile = false} = props || {};

    const {name, address, image, year, organizationName, organizationID} = objectData || {};

    const [imageUri, setImageUri] = useState('');

    useEffect(() => {
        setImageUri('');
        if (image) {
            setImageUri('/data/' + image?.toString().replace(/\\/g, '/'));
        }
    }, [image]);

    if (mobile) {
        const metadata = [
            {
                label: localizedStrings[localizedKeys.DRAWER_OBJECT_TEXT_YEAR],
                value: year,
                icon: <CalendarOutlined aria-hidden />,
            },
            {
                label: localizedStrings[localizedKeys.DRAWER_OBJECT_TEXT_APARTMENTS],
                value: roomsCount,
                icon: <AppstoreOutlined aria-hidden />,
            },
        ];

        return (
            <section className='map-building-mobile-summary'>
                <div className='map-building-mobile-identity'>
                    <img
                        className='map-building-mobile-photo'
                        src={imageUri || objectDefaultImage}
                        alt=''
                        onError={() => setImageUri('')}
                    />
                    <div className='map-building-mobile-identity-text'>
                        {name && <h2>{name}</h2>}
                        {address && (
                            <div className='map-building-mobile-address'>
                                <EnvironmentOutlined aria-hidden />
                                <span dangerouslySetInnerHTML={{__html: address}} />
                            </div>
                        )}
                        <dl className='map-building-mobile-metadata'>
                            {metadata.map(({label, value, icon}) => (
                                <React.Fragment key={label}>
                                    <dt>
                                        {icon}
                                        {label}
                                    </dt>
                                    <dd>{value !== null && value !== undefined && value !== '' ? value : '—'}</dd>
                                </React.Fragment>
                            ))}
                        </dl>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <>
            <section className={cn(className, 'w-full bg-white px-6')}>
                <div className={'relative w-full rounded-10 overflow-hidden shadow-table'}>
                    <img
                        className={`w-full h-[220px] object-cover bg-whisper`}
                        src={imageUri || objectDefaultImage}
                        alt=''
                    />

                    <div className='absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent' />

                    <div
                        className={
                            'absolute bottom-0 left-0 right-0 flex justify-between items-end text-white px-5 pb-5 pt-10'
                        }
                    >
                        <div className='flex flex-col gap-1 max-w-[65%]'>
                            {name && (
                                <div className='text-24 font-bold leading-12 [text-shadow:0_1px_4px_rgba(0,0,0,0.8)]'>
                                    {name}
                                </div>
                            )}
                            {address && (
                                <div className='flex items-center text-14 [text-shadow:0_1px_2px_rgba(0,0,0,0.8)]'>
                                    <IconLocationYellow className='mr-1.5 flex-shrink-0' />
                                    <span dangerouslySetInnerHTML={{__html: address}} />
                                </div>
                            )}
                        </div>

                        <div className='flex flex-col gap-1 text-right text-12 [text-shadow:0_1px_2px_rgba(0,0,0,0.8)]'>
                            {!isNaN(year) && (
                                <div className='leading-12'>
                                    <span className='opacity-80'>
                                        {localizedStrings[localizedKeys.DRAWER_OBJECT_TEXT_YEAR]}:{' '}
                                    </span>
                                    <span className='font-bold'>{year}</span>
                                </div>
                            )}
                            {!isNaN(roomsCount) && (
                                <div className='leading-12'>
                                    <span className='opacity-80'>
                                        {localizedStrings[localizedKeys.DRAWER_OBJECT_TEXT_APARTMENTS]}:{' '}
                                    </span>
                                    <span className='font-bold'>{roomsCount}</span>
                                </div>
                            )}
                        </div>
                    </div>

                    {isMenuButtonVisible && (
                        <div
                            className={
                                'cursor-pointer absolute top-3 right-3 flex justify-center items-center w-9 h-9 border border-white/20 rounded-full shadow-card_menu bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-colors'
                            }
                        >
                            <BuildingOptionsMenu />
                        </div>
                    )}
                </div>

                {organizationName && (
                    <div className={'flex flex-col justify-center items-center pt-4 bg-white'}>
                        <a
                            href={`${routePaths.ORGANIZATION_PAGE}/${organizationID}`}
                            className='text-18 font-bold text-zambezi text-center cursor-pointer hover:text-primary transition-colors'
                        >
                            {organizationName}
                        </a>
                    </div>
                )}

                {children}
            </section>
        </>
    );
};

export default ObjectImageCard;
